import React from 'react'

export const ClientContext = React.createContext(null)
